// extracted by mini-css-extract-plugin
module.exports = {"CreditScoreComments":"collateralComments_CreditScoreComments__YLBZe","Title":"collateralComments_Title__3T5J0","ActionBar":"collateralComments_ActionBar__2vXUb"};